{
  "home": {
    "fr": "/",
    "en": "/en"
  },
  "menu": {
    "fr": "/carte",
    "en": "/en/menu"
  },
  "gallery": {
    "fr": "/galerie",
    "en": "/en/gallery"
  },
  "privacy": {
    "fr": "/politique-confidentialite",
    "en": "/en/privacy"
  },
  "legal": {
    "fr": "/mentions-legales",
    "en": "/en/legal"
  }
}
